// =============================================================================
// Rotations API (art. 36 ET)
// =============================================================================
import { apiClient } from './http';

export interface RotationStepItem {
  position: number;
  shift_template_id: number | null;
  duration_days: number;
}

export interface RotationPatternItem {
  id: number;
  name: string;
  description: string | null;
  is_active: boolean;
  steps: RotationStepItem[];
  cycle_days: number;
  max_night_run_days: number;
}

export async function getRotationPatterns(): Promise<RotationPatternItem[]> {
  const response = await apiClient.get<RotationPatternItem[]>('/rotations');
  return response.data;
}

export async function createRotationPattern(data: {
  name: string;
  description?: string;
  steps: { shift_template_id: number | null; duration_days: number }[];
}): Promise<RotationPatternItem> {
  const response = await apiClient.post<RotationPatternItem>('/rotations', data);
  return response.data;
}

export async function assignRotation(
  patternId: number,
  data: { user_id: number; anchor_date: string; voluntary_night: boolean }
): Promise<{ id: number }> {
  const response = await apiClient.post(`/rotations/${patternId}/assign`, data);
  return response.data as { id: number };
}

export interface RotationAssignmentItem {
  id: number;
  user_id: number;
  pattern_id: number;
  anchor_date: string;
  voluntary_night: boolean;
  is_active: boolean;
  user_name: string | null;
  pattern_name: string | null;
}

export async function getRotationAssignments(): Promise<RotationAssignmentItem[]> {
  const response = await apiClient.get<RotationAssignmentItem[]>('/rotations/assignments');
  return response.data;
}

export async function deactivateRotationAssignment(assignmentId: number): Promise<void> {
  await apiClient.delete(`/rotations/assignments/${assignmentId}`);
}

export interface ShiftTemplateItem {
  id: number;
  name: string;
  code: string;
  start_time: string;
  end_time: string;
}

export async function getShiftTemplates(): Promise<ShiftTemplateItem[]> {
  const response = await apiClient.get<ShiftTemplateItem[]>('/rotations/shift-templates');
  return response.data;
}
